import { Optional } from '@/utils/types';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

type ResponseValue = {
	handleSearch: (searchVal: string) => void;
	searchQuery: Optional<string>;
};

export default function useSearchQuery(): ResponseValue {
	const [searchParams, setSearchParams] = useSearchParams();

	const handleSearch = useCallback(
		(search: Optional<string>) => {
			if (!search || search.length === 0) {
				searchParams.delete('s');
				setSearchParams(searchParams);
				return;
			}
			setSearchParams({
				s: search
			});
		},
		[searchParams, setSearchParams]
	);

	const searchQuery = searchParams.get('s');

	return { searchQuery, handleSearch };
}
